import { AlertTriangle, CheckCircle2, Eye } from "lucide-react"
import { Card, CardContent } from "@web/components/ui/card"
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@web/components/ui/accordion"
import { useLanguage } from "@web/lib/contexts/language-context"

export default function ExplanationSection() {
	const { t } = useLanguage()
	const explanations = [
		{
			icon: CheckCircle2,
			percentage: "80% - 100%",
			label: t.queryPage.explanationSection.levels.high.trust,
			description: t.queryPage.explanationSection.levels.high.description,
			colorClass: "text-emerald-600",
		},
		{
			icon: Eye,
			percentage: "60% - 79%",
			label: t.queryPage.explanationSection.levels.medium.trust,
			description: t.queryPage.explanationSection.levels.medium.description,
			colorClass: "text-amber-600",
		},
		{
			icon: AlertTriangle,
			percentage: "0% - 59%",
			label: t.queryPage.explanationSection.levels.low.trust,
			description: t.queryPage.explanationSection.levels.low.description,
			colorClass: "text-red-600",
		},
	]

	return (
		<Card className="bg-muted/30 border-dashed">
			<CardContent>
				<Accordion type="single" collapsible defaultValue="explanation">
					<AccordionItem value="explanation" className="border-none">
						<AccordionTrigger className="hover:no-underline py-0">
							<span className="font-semibold text-sm">{t.queryPage.explanationSection.title}</span>
						</AccordionTrigger>

						<AccordionContent>
							<div className="mt-2 space-y-4">
								{explanations.map((item, index) => {
									const Icon = item.icon
									return (
										<div key={item.percentage}>
											<div className={`flex items-center justify-center gap-2 mb-1 ${item.colorClass}`}>
												<Icon className="h-5 w-5" />
												<p className="font-bold text-lg">{item.percentage}</p>
											</div>

											<p className="text-center text-sm">
												<span className={`font-semibold ${item.colorClass}`}>{item.label}</span>
												{" — "}
												{item.description}
											</p>

											{index < explanations.length - 1 && (
												<div className="border-b mt-4" />
											)}
										</div>
									)
								})}
							</div>
						</AccordionContent>
					</AccordionItem>
				</Accordion>
			</CardContent>
		</Card>
	)
}